import ArrowBackIcon from '../../../assets/arrow-back-icon';
import React from 'react';
import Checkbox from '../../../components/checkbox';
import useGet from '../../../hook/use-get';
import { API } from '../../../helpers/constants';
import { SectionError } from '../../../components/error';
import FilterLoadingItem from './filter-loading-item';
import Modal from "../../../components/modal";

const RenderOptions = ({
   onSetValues,
   values,
   disabled,
   responseQuery,
   label,
   isRadio,
   options
}) => {
  const {isFetching, isError, refetch} = responseQuery

  if (isFetching || disabled) {
    return <FilterLoadingItem label={label} />;
  }

  if (isError) {
    return (
      <>
        <h3 className="text-left text-base font-semibold">{label}</h3>
        <div className="h-40 justify-center items-center flex">
            <SectionError refetch={refetch} classNames="flex flex-col px-0" />
        </div>
      </>
    );
  }

  return (
    <div className="space-y-2 text-left">
        <h3 className="text-left text-base font-semibold">{label}</h3>
        {options?.map((item) => (
            <Checkbox
                label={item.label}
                value={item.value}
                id={item.value}
                checked={isRadio ? values === item.value : values?.includes?.(item.value)}
                onClick={() => onSetValues(item.value)}
                disabled={disabled}
            />
        ))}
    </div>
  );
};

const Div = ({children}) => (
    <>{children}</>
)

const FilterTransport = ({ onBack, onSetFilterOptions, filterOptions, disabled, isModal, isOpen }) => {
  const Wrapper = isModal ? Modal : Div
    const serviceResult = useGet({
        queryKey: 'services',
        api: API.filter.services,
    });

    // const companyResult = useGet({
    //     queryKey: 'companies',
    //     api: API.filter.company
    // });

    const classResult = useGet({
        queryKey: 'classes',
        api: API.filter.classes
    });

    const operationalResult = useGet({
        queryKey: 'operationals',
        api: API.filter.operational
    });

    const priceResult = useGet({
        queryKey: 'prices',
        api: API.filter.price
    });

  const onSetOptions = (optionName) => (value) => {
    const indexOf = filterOptions?.[optionName]?.indexOf?.(value);
    if (indexOf < 0) {
      onSetFilterOptions((prevState) => {
        return {
          ...prevState,
          [optionName]: [...prevState?.[optionName], value]
        };
      });
    } else {
      const newFilter = { ...filterOptions };
      newFilter?.[optionName]?.splice(indexOf, 1);
      onSetFilterOptions(newFilter);
    }
  };

  const onSetRadio = (optionName) => (value) => {
      const isSameValue = filterOptions?.[optionName] === value;
      onSetFilterOptions((prevState) => {
          return {
              ...prevState,
              [optionName]: isSameValue ? "" : value
          };
      })
  }

  if (typeof isOpen === "boolean" && !isOpen) {
      return null
  }

  return (
      <Wrapper>
          <div className="mx-8 md:mx-0 rounded-lg bg-white space-y-3 p-5 w-full h-[90%] md:h-auto overflow-auto">
            <span className="flex gap-2">
              <span className="block md:hidden" onClick={onBack}>
                <ArrowBackIcon />
              </span>
              <h2 className="text-left text-base font-bold">Filter Pencarian</h2>
            </span>
            <hr className="my-4" />
            <RenderOptions
              disabled={disabled}
              onSetValues={onSetOptions('service_id')}
              values={filterOptions?.['service_id']}
              options={serviceResult?.data?.map((item) => ({
                  value: item?.id,
                  label: item?.mnemonic
              }))}
              responseQuery={serviceResult}
              label="Jenis Pelayanan"
            />
            {/*<RenderOptions*/}
            {/*  disabled={disabled}*/}
            {/*  onSetValues={onSetOptions('company_id')}*/}
            {/*  values={filterOptions?.['company_id']}*/}
            {/*  options={companyResult?.data?.map((item) => ({*/}
            {/*      value: item?.id,*/}
            {/*      label: item?.name*/}
            {/*  }))}*/}
            {/*  responseQuery={companyResult}*/}
            {/*  label="Bus Perusahaan"*/}
            {/*/>*/}
            <RenderOptions
              disabled={disabled}
              onSetValues={onSetOptions('class_name')}
              values={filterOptions?.['class_name']}
              options={classResult?.data?.map((item) => ({
                  value: item?.name,
                  label: item?.name
              }))}
              responseQuery={classResult}
              label="Kelas"
            />
            <RenderOptions
              disabled={disabled}
              onSetValues={onSetOptions('operational_id')}
              values={filterOptions?.['operational_id']}
              options={operationalResult?.data?.map((item) => ({
                  value: item?.id,
                  label: item?.name
              }))}
              responseQuery={operationalResult}
              label="Jadwal Keberangkatan"
            />
            <RenderOptions
              disabled={disabled}
              onSetValues={onSetRadio('price_id')}
              values={filterOptions?.['price_id']}
              options={priceResult?.data?.map((item) => ({
                  value: item?.id,
                  label: item?.name
              }))}
              responseQuery={priceResult}
              label="Harga"
              isRadio={true}
            />
          </div>
      </Wrapper>
  );
};

export default FilterTransport;
